import React, { useRef, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import NewNav from "../components/NewNav";
import Footer from "../components/Footer";
import jsQR from "jsqr";
import config from "../config.js";

const Support = () => {


   const parseWarrantyString = (str) => {
    const lines = str.split('\n');
    const data = {};
    
    lines.forEach(line => {
      const [key, ...rest] = line.split(':');
      if (key && rest.length > 0) {
        data[key.trim().toLowerCase().replace(/\s/g, '_')] = rest.join(':').trim();
      }
    });
    
    return data;
  };
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [showCamera, setShowCamera] = useState(false);
  const [stream, setStream] = useState(null);
  const [scannedCode, setScannedCode] = useState("");
  const [warrantyData, setWarrantyData] = useState(null);
  const [error, setError] = useState("");

  const startCamera = async () => {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const videoDevices = devices.filter((device) => device.kind === "videoinput");
      const realCamera =
        videoDevices.find(
          (device) =>
            !device.label.toLowerCase().includes("iriun") &&
            !device.label.toLowerCase().includes("virtual")
        ) || videoDevices[0];

      if (!realCamera) {
        alert("No real camera found.");
        return;
      }
      const mediaStream = await navigator.mediaDevices.getUserMedia({
        video: { deviceId: realCamera.deviceId },
        audio: false,
      });
      setStream(mediaStream);
      setShowCamera(true);
      setScannedCode("");
      setWarrantyData(null);
      setError("");

      setTimeout(() => {
        if (videoRef.current) {
          videoRef.current.srcObject = mediaStream;
          videoRef.current.play().catch((err) => {
            console.error("Error playing video:", err);
          });
          scanFrame();
        }
      }, 500);
    } catch (err) {
      alert("Camera access denied or not supported.");
      console.error("Camera error:", err);
    }
  };

  const stopCamera = () => {
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
    }
    setStream(null);
    setShowCamera(false);
  };

  // Scan video frames for QR code
  const scanFrame = () => {
    if (!videoRef.current || videoRef.current.readyState !== videoRef.current.HAVE_ENOUGH_DATA) {
      requestAnimationFrame(scanFrame);
      return;
    }

    const video = videoRef.current;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);

    const code = jsQR(imageData.data, canvas.width, canvas.height);

    if (code) {
      setScannedCode(code.data);
      fetchWarranty(code.data);
      stopCamera();
    } else {
      requestAnimationFrame(scanFrame);
    }
  };

  // Fetch warranty data from backend API
  const fetchWarranty = async (barcode) => {
    try {
      const encodedBarcode = encodeURIComponent(barcode.trim());
      const response = await fetch(`${config.API_BASE_URL}/api/warranty/${encodedBarcode}`);

      if (!response.ok) {
        throw new Error("Warranty info not found.");
      }

      const data = await response.json();
      setWarrantyData(data);
      setError("");
    } catch (err) {
      setWarrantyData(null);
      setError(err.message);
    }
  };

  return (
    <>
      <NewNav />
      <div className="support-scanner-wrapper" style={{ padding: "2rem", textAlign: "center" }}>
        <div className="scanner-card" style={{ marginBottom: "1rem" }}>
          <h2>Scan Product QR CODE</h2>
          <button
            className="start-camera-btn"
            onClick={startCamera}
            style={{
              padding: "0.5rem 1rem",
              fontSize: "1.2rem",
              cursor: "pointer",
              marginTop: "1rem",
            }}
          >
            Start Camera
          </button>
        </div>

        <Modal show={showCamera} onHide={stopCamera} centered size="lg" className="camera-modal">
          <Modal.Body style={{ textAlign: "center" }}>
            <div className="camera-container">
              <video
                ref={videoRef}
                autoPlay
                playsInline
                muted
                style={{
                  width: "100%",
                  height: "400px",
                  borderRadius: "8px",
                  backgroundColor: "black",
                }}
              />
              <Button
                variant="danger"
                className="close-camera-btn"
                onClick={stopCamera}
                style={{ marginTop: "1rem" }}
              >
                Close Camera
              </Button>
            </div>
            <canvas ref={canvasRef} style={{ display: "none" }} />
          </Modal.Body>
        </Modal>
<div>
   
  {scannedCode && (() => {
    const parsed = parseWarrantyString(scannedCode);

  console.log("Parsed Data:", parsed);
    return (
      <div
        style={{
          border: "1px solid #ccc",
          padding: "1rem",
          borderRadius: "8px",
          maxWidth: "400px",
          margin: "auto",
          textAlign: "left",
        }}
      >
        <h3>Warranty Details</h3>
        <p><b>Warranty:</b> {parsed['warranty_name'] || 'N/A'}</p>
        <p><b>Start Date:</b> {parsed['start_date'] || 'N/A'}</p>
        <p><b>End Date:</b> {parsed['end_date'] || 'N/A'}</p>
      </div>
    );
  })()}
  {error && <p style={{ color: "red", display: "none" }}>{error}</p>}
</div>

</div>  
      <Footer />
    </>
  );
};

export default Support;
